import { mapGetters } from 'vuex';
import HumanDate from '../filters/HumanDate';
import IsDeleted from '../filters/IsDeleted';

const ShowSingleVersion = {
    data() {
        return {
            item: {},
            meta: {
                selectedDate: window.moment().toISOString(),
                selectedVersion: '',
                versions: [],
            },
            isInitLoading: true,
            isVersionLoading: false,
            mode: 'show',
            iframeLink: '',
        };
    },
    filters: { HumanDate, IsDeleted },
    computed: {
        ...mapGetters('icons', [
            'getAllIcons',
        ]),
        getWorkingItem() {
            /** This is made beacuse some DTO is mapped in "info" object while others is in the root DTO */
            return this.item.info || this.item;
        },
        modeShowInfo() {
            return this.mode === 'show';
        },
        modeUpdate() {
            return this.mode === 'update' || this.mode === 'newVersion';
        },
        itemExists() {
            return Object.keys(this.item).length > 0;
        },
        heighestVersionNumber() {
            if (this.meta.versions.length === 0) {
                return -1;
            }
            return this.meta.versions.reduce((prev, current) => ((prev.versionNumber > current.versionNumber) ? prev : current)).versionNumber;
        },
        isUpdateVersion() {
            const publishDate = window.moment(this.getWorkingItem.publishDate);
            const now = window.moment();

            return now.isBefore(publishDate);
        },
        isCreateNewVersion() {
            const publishDate = window.moment(this.getWorkingItem.publishDate);
            const now = window.moment();

            return now.isAfter(publishDate) && this.getWorkingItem.versionNumber === this.heighestVersionNumber;
        },
        selectedDateFormatted() {
            return window.moment(this.meta.selectedDate).format('YYYY-MM-DD HH:mm');
        },
    },
    methods: {
        setMode(mode) {
            const acceptedValues = ['show', 'update', 'newVersion'];
            if (acceptedValues.includes(mode)) {
                this.mode = mode;
                return;
            }

            this.mode = 'show';
        },
        async onSaved({ action }) {
            this.setMode('show');
            await this.getVersions();

            if (this.heighestVersionNumber > -1 && (action === 'newVersion' || action === 'update')) {
                this.meta.selectedVersion = this.meta.versions.find(v => v.versionNumber === this.heighestVersionNumber);
            }
            this.meta.selectedDate = window.moment(this.meta.selectedVersion.publishDate);
        },
        async getVersions() {
            try {
                const versions = await this.service.getSingleVersions(this.id);
                this.meta.versions = versions;
            } catch (error) {
                //
            }
        },
        async initLoad() {
            this.isInitLoading = true;
            try {
                await this.getVersions();
                await this.getSingleItem(this.meta.selectedDate);
                this.pageloaded();
                this.isInitLoading = false;
            } catch (error) {
                this.isInitLoading = false;
            }
        },
        async getSingleItem(date) {
            try {
                const item = await this.service.getSingle(this.id, date);
                this.item = item || {};

                this.updateIframeLink();
                this.detectIfSeletcedDateMatches();
            } catch (error) {
                this.item = {};
                this.detectIfSeletcedDateMatches();
            }
        },
        updateIframeLink() {
            const link = process.env.VUE_APP_PREVIEW_URL;
            const datetime = window.moment.utc(window.moment(this.selectedDateFormatted)).format('YYYY-MM-DD HH:mm');
            if (this.itemExists) {
                this.iframeLink = `${link}?id=${this.id}&type=${this.currentMedicineType}&datetime=${datetime}&debug=true`;
            }
        },
        detectIfSeletcedDateMatches() {
            const matchingVersion = this.meta.versions.find((date) => {
                const f = window.moment(date.publishDate).isSame(window.moment(this.meta.selectedDate));
                return f ? date : null;
            });

            if (matchingVersion) {
                this.meta.selectedVersion = matchingVersion;
            } else {
                this.meta.selectedVersion = '';
            }
        },
    },
    async created() {
        if (this.$route.query.date) {
            const date = window.moment(this.$route.query.date);
            if (date) {
                this.meta.selectedDate = date.toISOString();
            }
        }

        await this.initLoad();
    },
    watch: {
        'meta.selectedDate': async function detectChangesSelectedDate(newValue) {
            if (!this.isInitLoading) {
                await this.getSingleItem(newValue);
            }
            window.history.replaceState({}, '', `?date=${window.moment(newValue).format('YYYY-MM-DD HH:mm')}`);
        },
    },
};

export default ShowSingleVersion;
